import * as React from 'react';
import injectSheet from 'react-jss';
import { Modal, Row, Col, Tooltip, Icon, Button, message, Spin } from 'antd';
import { connect } from 'react-redux';
import withInquiryMasterData from '../hoc/InitInquiryMaster';
import * as  moment from 'moment';
import { fetchAllBidsForBooking } from 'src/api/booking';
import Loader from 'src/components/common/Loader';
import TaxWarning from '../../../common/TaxWarning';
import PricePerContainer from '../../../common/PricePerContainer';
import PriceTotal from '../../../common/PriceTotal';
import { BID_ROUTES_CARD_LABELS, BookingSource, getBidTotal, getDomesticCharges, getUnitByMode, InquiryModes } from '../InquiryUtils';
import { isValidArray, isValidNumber, getDateValue } from 'src/Library/Helper';
import { commonStyles } from 'src/Library/CommonStyles';
import _ from 'lodash';
import { DownloadDocument } from 'src/components/common/DownloadDocument';
import FieldRate from 'src/components/common/form/FieldRate';
import { tokens } from 'src/design-system';

const styles = theme => ({
  modal: {
    border: '1px solid #E8E8E8',
    borderRadius: `${tokens.radius.md}px`,
    paddingBottom: '0px',
    marginBottom: '10px',
    minWidth: '1200px',
  },
  body: {
    marginTop: '30px',
    marginBottom: '30px',
    padding: '24px 24px 24px 24px',
    height: '100%',
  },
  title: {
    fontSize: `${tokens.fontSize.h3}px`,
    fontWeight: 'bold',
  },
  tableRow: {
    fontSize: `${tokens.fontSize.body}px`,
    color: '#262626',
    fontWeight: tokens.fontWeight.semibold,
  },
  cardContainer: {
    minHeight: '140px',
    maxHeight: '200px',
    marginTop: '8px',
    padding: '16px 16px 13px 16px',
    backgroundColor: tokens.colors.bgWhite,
    border: '1px solid #D9D9D9',
    borderRadius: `${tokens.radius.md}px`,
    '& .ant-radio-wrapper': {
      float: 'left',
      paddingTop: '4px',
    },
    '& .ant-radio': {
      float: 'left',
    },
  },
  cardHeaderItemsStyle: {
    fontSize: '11px',
    marginBottom: '10px',
    color: '#595959',
  },
  info: {
    fontSize: '13px',
    fontWeight: tokens.fontWeight.semibold,
    color: '#111',
    float: 'right',
    width: '44%',
    padding: '0px 0px 0px 5px',
    lineHeight: '100%',
  },
  dateStyle: {
    fontSize: '13px',
    fontWeight: tokens.fontWeight.semibold,
    color: '#111',
    float: 'right',
    width: '56%',
    padding: '0px 0px 0px 5px',
    lineHeight: '100%',
  },
  rankOneTag: {
    backgroundColor: '#DFDDFF',
    borderRadius: `${tokens.radius.md}px`,
    border: '1px solid #4A3CE4',
    width: '68px',
    padding: '2px 8px',
    minHeight: '20px',
    margin: '16px 0px 0px',
  },
  rankTag: {
    fontSize: `${tokens.fontSize.h3}px`,
    color: '#262626',
    margin: '16px 0px 0px',
  },
  ellipsis: {
    ...commonStyles(theme).ellipses,
  },
  domesticInfo: {
    fontSize: `${tokens.fontSize.small}px`,
    fontWeight: tokens.fontWeight.semibold,
    color: '#111',
    padding: '0px 0px 0px 5px',
  },
});

const COLORS = {
  GREEN: '#52C41A',
};

class ViewBidRanking extends React.PureComponent<any, any> {
  state: any = {
    confirmingBid: false,
    selectedBid: undefined,
    isLoading: true,
  };

  async componentDidMount() {
    this.fetchAllBidsForBooking();
  }

  fetchAllBidsForBooking = async () => {
    const { bookingId, shipperId } = this.props;
    const bidRankingApiData = {
      bookingId,
      shipperId,
      rankingCriteria: 'RANK_WITHOUT_TAX',
      bookingOrigin: 'INQUIRY',
    };
    const response = await fetchAllBidsForBooking(bidRankingApiData);
    if (response.isSuccess) {
      this.setState({
        isLoading: false,
        bidRankingData: response.data,
      });
    } else {
      message.error(response.errorMessage);
    }
  }

  renderCol1 = (bidData) => {
    const { classes, vendorRating } = this.props;
    const vendorRated = bidData?.ffRating || 0;
    const vendorRatedLabel = vendorRated ? vendorRating[vendorRated - 1] : ''
    return (
      <Col span={6} style={{ paddingLeft: '10px' }}>
        <div
          style={{ fontSize: `${tokens.fontSize.body}px`, color: '#262626', width: '90%' }}
          className={classes.ellipsis}
        >
          <Tooltip title={bidData.ffName} placement="topLeft">
            {bidData.ffName}
          </Tooltip>
        </div>
        <div>
          <FieldRate
            isView={true}
            isFlex={true}
            styles={{ fontSize: `${tokens.fontSize.caption}px`, justifyItems: 'left' }}
            disabled={true}
            value={vendorRated}
            ratingViewLabel={vendorRatedLabel}
            maxChars={22}
            labelStyles={{ fontWeight: 500, fontSize: `${tokens.fontSize.small}px`, fontStyle: 'italic' }}
          />
        </div>
        <div style={{ marginTop: '8px' }}>
          <Tooltip title={bidData.ffCarrier}>
            <img src={bidData.carrierLogoUrl} />
          </Tooltip>
        </div>
        {this.props.bookingSource !== BookingSource.DIRECT_BOOKING && (
          <div className={bidData.rank === 1 ? classes.rankOneTag : classes.rankTag}>
            {bidData.rank && `Rank: ${bidData.rank}`}
          </div>
        )}
      </Col>
    );
  }

  renderCol2 = (bidData) => {
    const { classes, currency, mode } = this.props;
    if (!bidData || !bidData.otherDetails) return '';
    const roadModes = [InquiryModes.DOMESTIC, InquiryModes.RPTL];
    if (roadModes.includes(mode)) return this.renderDomesticCol2(bidData, classes, currency);
    const { otherDetails } = bidData;
    return (
      <Col span={6}>
        <div>
          {mode !== InquiryModes.TRAILER &&
          <div className={classes.cardHeaderItemsStyle}>Demurrage Free Days
            <span className={classes.info}>{otherDetails?.demurrageFreeDays ?? '-'}</span>
          </div>}
          <div className={classes.cardHeaderItemsStyle}>Detention Free Days
            <span className={classes.info}>{otherDetails?.detentionFreeDays ?? '-'}</span>
          </div>
          {mode === InquiryModes.TRAILER &&
          <div className={classes.cardHeaderItemsStyle}>Detention Cost Per Day
            <span className={classes.info}>{isValidNumber(otherDetails?.detentionCostPerDay?.amount) ?
            `${currency[`${otherDetails?.detentionCostPerDay?.currency}`]}${otherDetails?.detentionCostPerDay?.amount}`
            : '-'}</span>
          </div>}
          {!(mode === InquiryModes.TRAILER || mode === InquiryModes.LCL) && (
            <div className={classes.cardHeaderItemsStyle}>
              Combined Free Days
              <span className={classes.info}>{otherDetails?.combinedFreeDays ?? '-'}</span>
            </div>
          )}
          {mode !== InquiryModes.TRAILER &&
          <div className={classes.cardHeaderItemsStyle}>Transit Days
            <span className={classes.info}>{otherDetails?.transitDays ?? '-'}</span>
          </div>}
        </div>
      </Col>
    );
  }

  renderCol3 = (bidData) => {
    const { classes, mode } = this.props;
    const roadModes = [InquiryModes.DOMESTIC, InquiryModes.RPTL];

    return (
      <Col span={6}>
        <div>
        {
          mode === InquiryModes.TRAILER ?
          <div className={classes.cardHeaderItemsStyle}>Round Trip Time
            <span className={classes.dateStyle}>
              {isValidNumber(bidData.otherDetails?.roundTripTime?.value) ?
                `${bidData.otherDetails?.roundTripTime?.value} ${bidData.otherDetails?.roundTripTime?.type}`
                : '-'}</span>
          </div> :
          <React.Fragment>
            <div className={classes.cardHeaderItemsStyle}>Schedule
              <span className={classes.dateStyle}>
                {bidData && bidData.otherDetails &&
                  bidData.otherDetails.schedule && bidData.otherDetails.schedule.length > 0 ?
                  bidData.otherDetails.schedule.map(item => `${item[0].toUpperCase()} `)
                  : '-'}
              </span>
            </div>
            {bidData?.otherDetails?.etd && <div className={classes.cardHeaderItemsStyle}>
              ETD <Tooltip title={
                    mode === InquiryModes.AIRCARGO ? 'Flight Date' 
                    : (roadModes.includes(mode) ? 'Departure Date' 
                    :'Sailing Date')
                    }>
                <Icon type="exclamation-circle" theme="filled" />
                </Tooltip>
              <span className={classes.dateStyle}>
                {getDateValue(bidData?.otherDetails?.etd)?.format('DD MMM YYYY') || '-'}
              </span>
            </div>}
          </React.Fragment>}
          <div className={classes.cardHeaderItemsStyle}>Valid Till
            <span className={classes.dateStyle}>
              {bidData && bidData.validTill ?
                moment(bidData.validTill).format('DD MMM YYYY') : '-'}</span>
          </div>
          {!roadModes.includes(mode) ? <div className={classes.cardHeaderItemsStyle}>
            Route
            <span className={classes.dateStyle}>
              {bidData.otherDetails.route?.map(item => BID_ROUTES_CARD_LABELS[item] || item).join(', ') || '-'}
            </span>
          </div> : null}
          {bidData.otherDetails.transshipmentVia &&<div className={classes.cardHeaderItemsStyle}>Transshipment
            <Tooltip title={bidData.otherDetails.transshipmentVia?.length > 1 ?
                bidData.otherDetails.transshipmentVia.map(item =>
                  <div>{item.label}</div>) : ''}>
              <span className={classes.dateStyle}>
                {isValidArray(bidData.otherDetails.transshipmentVia)
                  ? bidData.otherDetails.transshipmentVia[0].label : '-'}
                {bidData.otherDetails.transshipmentVia && bidData.otherDetails.transshipmentVia.length <= 1 ? ''
                  : ` +${bidData.otherDetails.transshipmentVia &&
                  bidData.otherDetails.transshipmentVia.length - 1}`}
              </span>
            </Tooltip>
          </div>}
        </div>
      </Col>
    );
  }

  renderCol4 = (bidData) => {
    const { classes, mode } = this.props;
    const roadModes = [InquiryModes.DOMESTIC, InquiryModes.RPTL];
    if (roadModes.includes(mode)) {
      const currencySymbol = this.props.currency[`${bidData?.userTotalWithoutTax?.currency}`]
      return <Col span={4} style={{display: 'flex', 'alignContent': 'center', columnGap: '10px'}}>
        <div>Total Price</div>
        <div style={{fontWeight: 600}}>{currencySymbol} {getBidTotal(bidData?.userTotalWithoutTax?.amount)}</div>
      </Col>
    };
    return (
      <Col span={4}>
        <div style={{ margin: '0px 15px' }}>
          <PricePerContainer
            mode={mode}
            amount={bidData.totalPerUnit.amount}
            currency={bidData.totalPerUnit.currency}
            containerTypes={bidData.totalPerUnitType}
            freightPerUnit={bidData.freightPerUnit}
            sourceObjectType={'BID'} />
          <div style={{ display: 'flex', alignItems: 'center' }}>
          <PriceTotal
            amount={bidData.shipperTotalWithoutTax.amount}
            currencySymbol={this.props.currency[`${bidData.shipperTotalWithoutTax.currency}`]}/>
          </div>
        </div>
      </Col>
    );
  }

  renderCol5 = (bidData) => {
    const { classes, currency, mode } = this.props;
    if (!bidData || !bidData.otherDetails) return '';
    const { otherDetails } = bidData;
    if (_.isNil(otherDetails.termsAndConditions)) return '';
    return (
      <Col span={1}>
          <div className={classes.cardHeaderItemsStyle}>
            <span className={classes.info}>
                 <DownloadDocument 
                      tooltip='Terms And Conditions'
                      url={otherDetails.termsAndConditions.url}
                      progressMessage='Downloading Terms & Conditions File ...'
                      filename={otherDetails.termsAndConditions.name}
                    />
            </span>
          </div>
      </Col>
    );
  }

  renderDomesticCol2 = (bidData, classes, currency) => {
    const { chargeDetails, otherDetails } = bidData;
    const { freightCharges, originCharges, destinationCharges } = chargeDetails;
    const isExchangeDatePresent = bidData?.exchangeRateDate;
    const currencySymbol = this.props.currency[`${bidData?.userTotalWithoutTax?.currency}`]
    return (
      <Col span={6}>
        <Row>
          <Col span={10} className={classes.cardHeaderItemsStyle}>
            Transport Charges
          </Col>
          <Col span={14} className={classes.domesticInfo}>
            {getDomesticCharges(freightCharges, isExchangeDatePresent, currencySymbol)}
          </Col>
        </Row>
        <Row>
          <Col span={10} className={classes.cardHeaderItemsStyle}>
            Origin Charges
          </Col>
          <Col span={14} className={classes.domesticInfo}>
            {getDomesticCharges(originCharges, isExchangeDatePresent, currencySymbol)}
          </Col>
        </Row>
        <Row>
          <Col span={10} className={classes.cardHeaderItemsStyle}>
            Destination Charges
          </Col>
          <Col span={14} className={classes.domesticInfo}>
            {getDomesticCharges(destinationCharges, isExchangeDatePresent, currencySymbol)}
          </Col>
        </Row>
        <Row>
          <Col span={10} className={classes.cardHeaderItemsStyle}>
            Transit Days
          </Col>
          <Col span={14} className={classes.domesticInfo}>
            {otherDetails?.transitDays}
          </Col>
        </Row>
      </Col>
    );
  }

  renderFooter = () => {
    const { selectedBid } = this.state;

    return <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div></div>
      <Button
        loading={this.state.confirmingBid}
        type="primary"
        style={{ backgroundColor: tokens.colors.primary, border: tokens.colors.primary }}
        onClick={() => {
          this.props.handleCancel();
        }}>Close
      </Button>
    </div>;
  }

  onChangeBid = (e) => {
    this.setState({
      selectedBid: e.target.value,
    });
  }

  onCardRowClick = (item) => {
    this.setState({
      selectedBid : item,
    });
  }

  render() {
    const { classes, handleCancel, visible, mode } = this.props;
    const { selectedBid, bidRankingData } = this.state;

    return <Modal className={classes.modal}
      closable
      footer={this.props.booking ? this.renderFooter() : false}
      width="1200px"
      title={<div style={{ fontWeight: 800 }}>
        {'All Bids'}</div>}
      visible={visible}
      onCancel={() => handleCancel()}
    >
    <TaxWarning unit={getUnitByMode(mode)}/>
    { bidRankingData ?
      <>
        {bidRankingData.data.map(bid => (
          <div key={bid.id} style={
            ((bid.isSelected) ?
              { border: `1px solid ${COLORS.GREEN}` } : undefined)}
              className={classes.cardContainer}>
                <Row>
                  {this.renderCol1(bid)}
                  {this.renderCol2(bid)}
                  {this.renderCol3(bid)}
                  {this.renderCol4(bid)}
                  {this.renderCol5(bid)}
                </Row>
          </div>
        ))}
      </>
    : <div style={{
      width: '100%', display:'flex',
      zIndex: 1000,
      justifyContent:'center', alignItems: 'center' }}>
        <Spin/>
      </div>}
    </Modal>;
  }
}
const mapStateToProps = ({ inquiryFFReducer, masterData, inquiryReducer }, ownProps) => ({
  data: inquiryFFReducer,
  masterData: inquiryReducer.masterData,
  currency: masterData.currencySymbols,
  vendorRating: Object.values(masterData?.vendorRating?.mapping || {}),
});
export default withInquiryMasterData(injectSheet(styles)(connect(mapStateToProps,
  null)(ViewBidRanking)));
